// extracted by mini-css-extract-plugin
export var actionButton = "_7h-0";
export var attachmentLine = "_7h-1";
export var fileInput = "_7h-2";
export var fileUploadWrapper = "_7h-4";
export var footer = "_7h-3";
export var modalContent = "_7h-5";
export var paperclip = "_7h-6";
export var quillEditor = "_7h-7";